import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

//DETALLES DE REQUISA FILTRADORS POR FECHA
export const SalidasMaterialesDetalles = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/listadoSalidasMPorFecha', 'POST', data);
}

//OBTIENE LAS SALIDAS POR FECHA 
export const SalidasMDetalles = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/listadoSalidasPorFecha', 'POST', data);
}

//OBTIENE LAS SALIDAS DE MATERIA PRIMA
export const SalidasMP = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/listadoSalidasMP', 'POST', data);
}

//OBTIENE DETALLE SALIDA POR REQUISA
export const ObtenerDetalleSalidas = async (Requisa) => {
  const result = await PrivateInterceptor(`Suministros/SalidasMaterial/ObtenerDetallesSalidas`, "POST",{ Requisa });
  return result;
};

//GUARDAR SALIDAS
export const guardarSalidaM = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/AgregarSalidaMaterial', 'POST', {data});
}

// GUARDAR SALIDA DE MATERIA PRIMA POR PACAS
export const guardarSalidaMP = async (data) => {
  return await PrivateInterceptor(
    "Suministros/SalidasMaterial/AgregarSalidaMateriaPrima",
    "POST",
    { data }
  );
};

// OBTENER PACAS DISPONIBLES PARA SALIDA DE MATERIA PRIMA
export const obtenerPacasDisponiblesSalida = async (IdProduct) => {
  return await PrivateInterceptor(
    "Suministros/SalidasMaterial/PacasDisponiblesSalida",
    "POST",
    { IdProduct }
  );
};

// OBTIENE DETALLE DE SALIDAS DE PACAS
export const obtenerDetalleSalidaPacas = async (data) => {
  return await PrivateInterceptor(
    "Suministros/SalidasMaterial/DetalleSalidaPacas",
    "POST",
    data
  );
};

// OBTIENE LAS PACAS DE UNA SALIDA ESPECIFICA PARA REPORTE
export const obtenerDetalleSalidaPacasPorSalida = async (IdSalidaDetalle) => {
  return await PrivateInterceptor(
    "Suministros/SalidasMaterial/DetalleSalidaPacasPorSalida",
    "POST",
    { IdSalidaDetalle }
  );
};

//EDITAR SALIDAS
export const editarSalidaM = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/EditarSalidaMaterial', 'POST', {data});
}

//ELIMINA UNA SALIDA DE MATERIAL
export const EliminarSalidasMateriales = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/eliminarRegistro', 'POST', {data});
}

//OBTIENE LAS SALIDAS
export const ObtenerSalidasT = async () => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/ObtenerSalidasT', 'GET');
}

//OBTIENE LAS SALIDAS CON BALANCE > 0
export const ObtenerSalidasConBalance = async () => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/ObtenerSalidasConBalance', 'GET');
}

export const ListaProductosMinimos = async (IdProduct) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/ProductosConMinimo', 'POST', {IdProduct});
}

//OBTIENE LAS SALIDAS POR FECHA PARA HACER DEVOLUCIONNES
export const SalidasParaDevoluciones = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/listadoSalidasParaDevoluciones', 'POST', data);
}

export const agregarConstruccionSalidas = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/agregarConstruccionSalidas', 'POST', {data});
}

export const agregarCuentaSalidas = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/agregarCuentaSalidas', 'POST', {data});
}

export const revisarSalidaFin = async (data) => {
  return await PrivateInterceptor('Suministros/SalidasMaterial/revisarSalidaFin', 'POST', {data});
}
